import React, {useEffect, useState} from "react";

/**
 *
 * @type {number}
 */
const DEFAULT_DEBOUNCE_TIMEOUT = 50;

/**
 * bootstrap's marker for mobile width, 480px or lower screens are considered 'mobile'
 * @type {number}
 */
const MOBILE_SCREEN_BREAKPOINT = 480;

/**
 * Non-hook variant for imperative call sites that only need the at-call-time answer.
 * @param {number} screenWidth
 * @returns {boolean}
 */
export const isMobileScreenWidth = (screenWidth) => {
    return screenWidth <= MOBILE_SCREEN_BREAKPOINT;
}

export const useIsMobileWidth = (debounceTimeout = DEFAULT_DEBOUNCE_TIMEOUT) => {
    const [isMobileWidth, setIsMobileWidth] = useState(isMobileScreenWidth(window.innerWidth));

    useEffect(() => {
        const resizeHandler = PMW.debounce(() => {
            const isCurrentWindowWidthMobile = isMobileScreenWidth(window.innerWidth);
            if (isCurrentWindowWidthMobile !== isMobileWidth) {
                setIsMobileWidth(isCurrentWindowWidthMobile);
            }
        }, debounceTimeout);

        window.addEventListener('resize', resizeHandler, {passive: true})

        return () => {
            resizeHandler.clear();
            window.removeEventListener('resize', resizeHandler);
        }
    })

    return isMobileWidth;
}